/**
 * Item Value Not String
 */
export default ['type', 'exchangeRate', 'index'];
